module.exports = __webpack_public_path__ + "img/021.53dad67b.jpg";